import React, { Component } from 'react'
import Style from './style.module.less'
import { observer } from 'mobx-react'
import { PreviewModal } from 'hlj-components'

@observer
export default class extends Component {
  render() {
    const { store } = this.props
    const { video, video_modal } = store

    return (
      <PreviewModal
        visible={video_modal}
        onCancel={store.changeVideoModal(false)}
        destroyOnClose={true}
      >
        <video
          muted="muted"
          autoPlay
          controls
          src={video.cover_path}
          className={Style.video}
        />
      </PreviewModal>
    )
  }
}
